import { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Icon from "components/elements/icon";
import WithSession from "base/session/with-session";
import TodoDateSelectionCalendar from "apps/todo/components/todo-date-selection-calendar";
import { OutsideClick, Button } from "@evertrue/et-components";

const DAY_MILLS = 1 * 24 * 60 * 60 * 1000;

class DatePanel extends Component {
  static propTypes = {
    selectedDateChangedTo: PropTypes.func,
    currentDate: PropTypes.number,
    toggleCalendar: PropTypes.func,
    isCalendarOpen: PropTypes.bool,
  };
  static defaultProps = {
    selectedDateChangedTo: () => {},
    currentDate: new Date(),
    toggleCalendar: () => {},
    isCalendarOpen: false,
  };

  incrementDate = () => {
    const date = this.props.currentDate + DAY_MILLS;
    this.props.selectedDateChangedTo(date);
  };
  decrementDate = () => {
    const date = this.props.currentDate - DAY_MILLS;
    this.props.selectedDateChangedTo(date);
  };

  newDateSelected = (date) => {
    const millisecond_date = moment(date).valueOf();
    this.props.selectedDateChangedTo(millisecond_date);
    this.props.toggleCalendar();
  };

  todayClicked = () => {
    this.props.selectedDateChangedTo(moment().valueOf());
    this.props.toggleCalendar();
  };

  calendarOutsidesClicked = () => {
    // this check is in place to prevent button click and outside click from invoking toggle together.
    if (this.props.isCalendarOpen) {
      this.props.toggleCalendar();
    }
  };

  renderBottomComponent = () => {
    return (
      <div className="todo-date-selection--button-wrapper">
        <Button
          type="simple"
          title="Select today's date"
          className="todo-date-selection--today-button"
          onClick={this.todayClicked}
        >
          TODAY
        </Button>
      </div>
    );
  };

  render() {
    const selected_day = moment(this.props.currentDate).format("DD");
    const selected_day_of_week = moment(this.props.currentDate).format("dddd");
    const month_year_str = moment(this.props.currentDate).format("MMM YYYY");
    return (
      <OutsideClick onOutsideClick={this.calendarOutsidesClicked}>
        <div className="date-panel">
          <button className="date-panel--decrement-button" onClick={this.decrementDate}>
            <Icon icon="chevron-left" />
          </button>
          <div className="date-panel--date-holder">
            <Button
              type="simple"
              title="Toggle calendar"
              className="date-panel--date-selection-button"
              onClick={this.props.toggleCalendar}
            />
            <div className="date-panel--day-holder">{selected_day}</div>
            <div className="date-panel--date-info-holder">
              <div className="date-panel--month-year-holder">{month_year_str}</div>
              <div className="date-panel--week-day-holder">{selected_day_of_week}</div>
            </div>
            {this.props.isCalendarOpen && (
              <TodoDateSelectionCalendar
                className="todo-calendar--extra-style"
                selectedDate={this.props.currentDate}
                bottomComponent={this.renderBottomComponent()}
                newDateSelected={this.newDateSelected}
                clockEnabled={false}
              />
            )}
          </div>
          <button className="date-panel--increment-button" onClick={this.incrementDate}>
            <Icon icon="chevron-right" />
          </button>
        </div>
      </OutsideClick>
    );
  }
}

export default WithSession(DatePanel);
